export default ["$stateProvider", "$urlRouterProvider",function ($stateProvider, $urlRouterProvider) {
    // Now set up the states
    $stateProvider
        .state("cardList", {
            parent : "app",
            url: "/cards?cardNr&formattedName&displayValidFrom&displayValidUntil&aggregatedData.transactionsThisYear.valueFrom&aggregatedData.transactionsThisYear.valueUntil&aggregatedData.transactions365.valueFrom&aggregatedData.transactions365.valueUntil&aggregatedData.loungeVisitsFrom&aggregatedData.loungeVisitsUntil&product.description&filterName&downloadError",
            feature: "menu.contracts",
            views: {
                "main": {
                    template: require("./eaCardPage/eaCardPageModule.html"),
                    controller: "CardPageModuleController as $ctrl"
                }
            },
            resolve : {
                ctrl : ["$q","$ocLazyLoad", ($q,$ocLazyLoad)=> {
                    return $q((resolve)=>{
                        require.ensure([],()=>{

                            let module = require("./index.js");
                            $ocLazyLoad.load({name : module.default});
                            resolve();
                        });
                    });
                }]
            }
        });
        /*.state('basicAgreementList', {
            parent : "app",
            url: "/basicAgreements?downloadError",
            feature: "menu.settings.notifications",
            views: {
                "main": {
                    template: require("./eaBasicAgreementPage/eaBasicAgreementPage.tpl.html"),
                    controller: "BasicAgreementPageController as $ctrl"
                }
            },
            resolve : {
                ctrl : ["$q","$ocLazyLoad", ($q,$ocLazyLoad)=> {
                    return $q((resolve)=>{
                        require.ensure([],()=>{

                            let module = require("./index.js");
                            $ocLazyLoad.load({name : module.default});
                            resolve();
                        });
                    });
                }]
            }
        });*/
      }];



// WEBPACK FOOTER //
// ./src/ui/modules/eaCard/routes.js